<template>
  <v-app class="grey lighten-4">
    <vue-snotify></vue-snotify>
    <component :is="layout">
        <router-view></router-view>
    </component>
  </v-app>
</template>

<script>
    const default_layout = "default";
    export default {
        name: 'App',
        components: {},
        computed: {
            layout() {
                return (this.$route.meta.layout || default_layout) + '-layout';
            }
        }
    };
</script>
